import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';
import { Box } from '@mantine/core';

type Props = PropsWithChildren<{
    accentClassName: string;
    ariaLabel?: string;
    contentClassName?: string;
}>;

export function QuickActionPanel({
    accentClassName,
    ariaLabel,
    contentClassName,
    children,
}: Props) {
    return (
        <Box
            role="group"
            aria-label={ariaLabel}
            w="100%"
            miw={0}
            className="flex overflow-x-hidden border-t border-r border-gray-200 bg-gray-50"
        >
            <div
                aria-hidden
                className={clsx(
                    'w-1 shrink-0 self-stretch rounded-r-sm',
                    accentClassName,
                )}
            />
            <Box
                className={clsx(
                    'min-w-0 flex-1 overflow-x-hidden',
                    contentClassName,
                )}
            >
                {children}
            </Box>
        </Box>
    );
}

export default QuickActionPanel;
